export const MOBILE = ["20", "30", "31", "38", "50", "70"];
export const LINE = [
	"22",
	"23",
	"24",
	"25",
	"26",
	"27",
	"28",
	"29",
	"32",
	"33",
	"34",
	"35",
	"36",
	"37",
	"42",
	"44",
	"45",
	"46",
	"47",
	"48",
	"49",
	"52",
	"53",
	"54",
	"56",
	"57",
	"59",
	"62",
	"63",
	"66",
	"68",
	"69",
	"72",
	"73",
	"74",
	"75",
	"76",
	"77",
	"78",
	"79",
	"82",
	"83",
	"84",
	"85",
	"87",
	"88",
	"89",
	"92",
	"93",
	"94",
	"95",
	"96",
	"99",
];
export const LENGTH_BY_COUNTRY_CODE = {
	1: [10],
	20: [8, 10],
	212: [9],
	213: [9],
	216: [8],
	218: [10],
	220: [7],
	221: [9],
	222: [8],
	223: [8],
	224: [8],
	225: [8],
	226: [8],
	227: [8],
	228: [8],
	229: [8],
	230: [8],
	231: [7, 8],
	232: [8],
	233: [9],
	234: [7, 10],
	235: [8],
	236: [8],
	237: [9],
	238: [7],
	239: [7],
	240: [9],
	241: [7],
	242: [9],
	243: [7, 9],
	244: [9],
	245: [7],
	246: [7],
	247: [4],
	248: [7],
	249: [9],
	250: [9],
	251: [9],
	252: [7, 8],
	//	253: [6],
	254: [10],
	255: [9],
	256: [9],
	257: [8],
	258: [12],
	260: [9],
	261: [9, 10],
	262: [9],
	263: [7, 9],
	264: [7, 10],
	265: [7, 8],
	266: [8],
	267: [7, 8],
	268: [8],
	269: [7],
	27: [9],
	290: [4],
	291: [7],
	297: [7],
	298: [5],
	//	299: [6],
	30: [10],
	31: [9],
	32: [8, 9],
	33: [9],
	34: [9],
	350: [8],
	351: [9, 11],
	352: [9],
	353: [8, 11],
	354: [7, 9],
	355: [9],
	356: [8],
	357: [8],
	358: [7, 12],
	359: [7, 9],
	36: [8, 9],
	370: [8],
	371: [7, 8],
	372: [7, 10],
	373: [8],
	374: [8],
	375: [9, 10],
	376: [7, 9],
	377: [7, 9],
	378: [7, 10],
	380: [9],
	381: [8, 9],
	382: [8],
	385: [9],
	386: [8],
	387: [8],
	389: [8],
	39: [9, 13],
	40: [9],
	41: [9],
	420: [9],
	421: [9],
	423: [7, 9],
	43: [4, 13],
	44: [10],
	45: [8],
	46: [6, 13],
	47: [8],
	48: [9],
	49: [6, 13],
	500: [5],
	501: [7],
	502: [8],
	503: [8],
	504: [8],
	505: [8],
	506: [8],
	507: [8],
	//	508: [6], Ütközik
	509: [8],
	51: [9],
	52: [10],
	53: [7, 8],
	54: [10, 11],
	55: [10, 11],
	56: [8, 9],
	57: [8, 10],
	58: [10],
	590: [9],
	591: [8],
	592: [7],
	593: [8],
	594: [9],
	595: [9],
	596: [9],
	597: [7],
	598: [7, 11],
	599: [7, 8],
	60: [7, 9],
	61: [9],
	62: [5, 11],
	63: [8, 10],
	64: [8, 10],
	65: [8, 12],
	66: [8, 9],
	670: [7, 8],
	672: [9],
	673: [7],
	674: [7],
	675: [7, 11],
	676: [7],
	677: [7],
	678: [7],
	679: [7],
	680: [7],
	// 681: [6],
	682: [5],
	683: [4],
	685: [5],
	686: [8],
	// 687: [6],
	// 688: [5, 6],
	// 689: [6],
	690: [4],
	691: [7],
	692: [7],
	7: [10],
	800: [8],
	808: [8],
	81: [9, 10],
	82: [8, 11],
	84: [7, 10],
	850: [6, 10],
	852: [4, 9],
	853: [7, 8],
	855: [8],
	856: [8, 9],
	86: [5, 12],
	870: [9],
	880: [6, 10],
	886: [8, 9],
	90: [10],
	91: [7, 10],
	92: [8, 11],
	93: [9],
	94: [9],
	95: [7, 9],
	960: [7],
	961: [7, 8],
	962: [5, 9],
	963: [8, 10],
	964: [8, 10],
	965: [7, 8],
	966: [8, 9],
	967: [6, 9],
	968: [7, 8],
	971: [8, 9],
	972: [9],
	973: [8],
	974: [6, 10],
	975: [7, 8],
	976: [7, 8],
	977: [8, 10],
	979: [9],
	98: [6, 10],
	992: [9],
	993: [8],
	994: [8, 9],
	995: [9],
	996: [9],
	998: [9],
};
export const COUNTRY_CODES = Object.keys(LENGTH_BY_COUNTRY_CODE);
